// Leo reports, one page each at /invoice/reports/:reportKey. The side nav (Invoice → Reports) lists them in this order.
export const REPORT_LIST: { key: string; title: string }[] = [
  { key: 'bsp-close', title: 'BSP close' },
  { key: 'monthly-close', title: 'Monthly close' },
  { key: 'jdv', title: 'JDV' },
  { key: 'jrm', title: 'JRM' },
  { key: 'jda', title: 'JDA' },
  { key: 'jdd', title: 'JDD' },
  { key: 'ar-ap', title: 'AR / AP' },
  { key: 'commissions', title: 'Agency commissions' },
]

export const REPORTS_PATH = '/invoice/reports'
